export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_33031.11348e8d.jpg";